import { render, staticRenderFns } from "./RIClaimsSummary.vue?vue&type=template&id=181582c6&"
import script from "./RIClaimsSummary.vue?vue&type=script&lang=js&"
export * from "./RIClaimsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports